import { Drawer } from 'vaul'
import {
  GlobalStyle,
  StyledClose,
  StyledCloseIcon,
  StyledContent,
  StyledOverlay,
} from './MobilePopup.styles'
import type { MobilePopupProps } from './MobilePopup.types'

export const MobilePopup = ({
  children,
  isVisible,
  setIsVisible,
}: MobilePopupProps): JSX.Element => {
  return (
    <>
      <GlobalStyle />
      <Drawer.Root open={isVisible} onOpenChange={setIsVisible}>
        <Drawer.Portal>
          <StyledOverlay />
          <StyledContent id="quick-add-popup">
            <StyledClose>
              <StyledCloseIcon width={24} height={24} />
            </StyledClose>
            {children}
          </StyledContent>
        </Drawer.Portal>
      </Drawer.Root>
    </>
  )
}
